import { object, string } from 'yup';
import text from '../text';
export var SPECIALIZATION_MAX_LENGTH = 100;
export var PHONE_REGEX = /^(?:\+?(61))? ?(?:\((?=.*\)))?(0?[2-57-8])\)? ?(\d\d(?:[- ](?=\d{3})|(?!\d\d[- ]?\d[- ]))\d\d[- ]?\d[- ]?\d{3})$/;
export var companyFormSchema = object().shape({
    name: string().required(text('required')),
    specialization: string().max(SPECIALIZATION_MAX_LENGTH, text('maxLength')).nullable(),
    phone: string().nullable().test('phone-validation', text('invalidPhone'), function(value) {
        if (!value) return true;
        return PHONE_REGEX.test(value);
    }),
    address: string().nullable(),
    website: string().nullable(),
    business_number: string().nullable()
});
